import { type RouteRecordRaw } from 'vue-router';

import { Role } from 'src/constants/app';
import { Subscription } from 'src/constants/subscription';
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'layout-main',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/Index.vue')
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('pages/Notifications.vue')
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('pages/Profile.vue')
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('pages/Settings.vue')
      },
      {
        path: 'nomenclature/:nomenc_code?',
        name: 'nomenclature',
        component: () => import('pages/Nomenclature.vue')
      },
      {
        path: 'regulations/:regulation/amendments',
        name: 'regulation_amendments',
        component: () => import('pages/RegulationAmendmentHistoryPage.vue'),
        meta: {
          authorize: {
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        }
      },
      {
        path: 'stepper',
        name: 'stepper',
        component: () => import('pages/StepperSearch.vue'),
        meta: {
          authorize: {
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        }
      },
      {
        path: 'classificationsearch',
        name: 'classificationsearch',
        component: () => import('pages/ClassificationSearch.vue'),
        meta: {
          authorize: {
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        }
      },
      {
        path: 'notes/:nomenc_code?',
        name: 'notes',
        component: () => import('pages/NotesSearch.vue'),
        meta: {
          authorize: {
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        }
      },
      {
        path: 'classificationfolder/:folder_code?',
        name: 'classificationfolder',
        component: () => import('pages/ResearchFolderList.vue'),
        meta: {
          authorize: {
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        }
      },
      {
        path: 'analytics',
        name: 'analytics',
        component: () => import('pages/Analytics.vue'),
        meta: {
          authorize: {
            acl: 'analytics',
            subscription: [Subscription.ENTERPRISE, Subscription.PRO, Subscription.PREMIUM]
          }
        } // acl is always a string
      },
      {
        path: 'declarations/statistics',
        name: 'statistics',
        component: () => import('pages/DeclarationStatistics.vue')
      },
      {
        path: 'declarations/periodic-customs-statements',
        name: 'periodic_customs_statements',
        component: () => import('pages/DeclarationPeriodicCustomsStatements.vue')
      },
      {
        // Second segment is either a numeric teledec id OR a subtype slug
        // (declaration | notification | report | import | export), parsed in DeclarationsPage.
        path: 'declarations/:type?/:teledec_id?',
        name: 'declarations',
        component: () => import('pages/DeclarationsPage.vue')
      },
      {
        path: 'admin/:tab?',
        name: 'admin',
        component: () => import('pages/Administration.vue'),
        meta: {
          authorize: { role: [Role.Admin, Role.SuperAdmin, Role.Maintainer] }
        } // role must always be an array
      },
      {
        path: 'customsbase/:id_customs_base?',
        name: 'customsbase',
        component: () => import('pages/CustomsBase.vue')
      }
    ]
  },
  {
    path: '/register',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'layout_register',
        component: () => import('pages/auth/Register.vue'),
        meta: {
          brandTitleKey: 'sign_up',
          brandSubtitleKey: 'welcome_registration',
          formPanelExtraClass: 'register-form-panel',
          formPanelDesktopAlign: 'start'
        }
      }
    ]
  },
  {
    path: '/reset_password',
    name: 'layout_reset_password',
    component: () => import('pages/auth/ResetPassword.vue')
  },
  {
    path: '/login',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('pages/auth/Login.vue'),
        meta: {
          brandTitleKey: 'welcome_back_message',
          brandSubtitleKey: 'welcome_back_caption',
          brandShowProductName: true
        }
      }
    ]
  }
];

// Always leave this as last one
routes.push({
  path: '/:catchAll(.*)*',
  name: 'layout-catch-all',
  component: () => import('pages/Error404.vue')
});

export default routes;
